import { OverflowOptionItem } from '@/components/Document/OverflowOptions/OverflowOption';

export const DefaultPlaceHolder = '프롬프트를 입력하거나 선택해 주세요.';
export const DefaultPromptID = 'direct';

export const PresetPromptItem: OverflowOptionItem[] = [
  {
    id: 'core_problem',
    label: '핵심 문제는 뭐였어?',
    prompt: '핵심 문제는 뭐였어?',
  },
  {
    id: 'summarize_share',
    label: '공유를 위해 요약해줘',
    prompt: '공유를 위해 요약해줘',
  },
  {
    id: 'next_action',
    label: '다음에 해야할 것은 뭐야?',
    prompt: '다음에 해야할 것은 뭐야?',
  },
  {
    id: 'decisions',
    label: '결정된 사항은 뭐였어?',
    prompt: '결정된 사항은 뭐였어?',
  },
];
